export default {
  SET_ENTRIES: 'setEntries',
  ADD_ENTRY: 'addEntry',
  UPDATE_ENTRY: 'updateEntry',
  UPSERT_ENTRY: 'upsertEntry',
  REMOVE_ENTRY: 'removeEntry',
}